import client from 'lib/api/client';
import {TCutLists} from 'modules/cut';

/**
 * 영상 저장 API
 */

// export interface ISetEditorJob {
//     edit_job_info: ICutInfos[];
// }

export interface ISetEditorJob {
  edit_job_info: TCutLists[][];
  edit_type: number;
  title_no: number;
  broad_no: number;
  shade_duration: number;
  shade_area: TCutLists[][];
  version: number;
  RESULT?: number;
  MSG?: string;
}

export interface ICutInfos {
  edit_cut_infos: {
    cut_time_infos: {
      cut_duration: string;
      cut_start_time: string;
    };
    duration_ms: number; // 이건 mediainfo로 vodInfo.php에서 뽑아서 오므로 그대로 전송
    file_info_key: string;
    file_order: number;
    // file_path: string;
    // file_size: number;
    // file_type: string;
    // grade: number;
    // hide: string;
    // region_type: number;
  };
}

export async function setEditor(savePost: ISetEditorJob) {
  const {
    edit_job_info,
    edit_type,
    title_no,
    broad_no,
    shade_duration,
    shade_area,
    version,
  } = savePost;
  const form = new FormData();
  form.append('edit_job_info', JSON.stringify(edit_job_info));
  form.append('edit_type', JSON.stringify(edit_type));
  form.append('title_no', JSON.stringify(title_no));
  form.append('broad_no', JSON.stringify(broad_no));
  form.append('shade_duration', JSON.stringify(shade_duration));
  form.append('shade_area', JSON.stringify(shade_area));
  form.append('version', JSON.stringify(version));
  const response = await client.post<ISetEditorJob>(
    '/vodeditor/api/setSectionEditorJob.php',
    form,
    {
      headers: {
        'content-type': 'multipart/form-data',
      },
    },
  );
  return response.data;
}
